var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalMaterials(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2238_5448",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 41,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.826172,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2238_5448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8411 23.3333H22.5078V20H15.8411V23.3333ZM15.8411 18.3333H29.1745V15H15.8411V18.3333ZM15.8411 13.3333H29.1745V10H15.8411V13.3333ZM12.5078 30C11.5911 30 10.8064 29.6736 10.1536 29.0208C9.50087 28.3681 9.17448 27.5833 9.17448 26.6667V6.66667C9.17448 5.75 9.50087 4.96528 10.1536 4.3125C10.8064 3.65972 11.5911 3.33334 12.5078 3.33334H32.5078C33.4245 3.33334 34.2092 3.65972 34.862 4.3125C35.5148 4.96528 35.8411 5.75 35.8411 6.66667V26.6667C35.8411 27.5833 35.5148 28.3681 34.862 29.0208C34.2092 29.6736 33.4245 30 32.5078 30H12.5078ZM5.84115 36.6667C4.92448 36.6667 4.13976 36.3403 3.48698 35.6875C2.8342 35.0347 2.50781 34.25 2.50781 33.3333V10H5.84115V33.3333H29.1745V36.6667H5.84115Z",
    fill: "#A435F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalMaterials);
export default __webpack_public_path__ + "static/media/TotalMaterials.928772d3134c88c82124a55b5f86b35c.svg";
export { ForwardRef as ReactComponent };